import React from "react";
import { TspSkeleton } from "../../../components/primitives";
import TspLoadError from "../../../components/common/TspLoadError";
import { useTspCityKnowledge, useTspKnowledgePerms } from "../../knowledge-repository/useTspKnowledgeData";
import { CityKnowledgeSections } from "../../knowledge-repository/components/CitySections";

// "View Summary" on the Update Journey screen, opened in place under the stop:
// the same summary of the place as the Knowledge Repository page (every record
// from the completed journeys that visited it), loaded from the same API.
export default function JourneyCitySummary({ locationId, cityName }) {
  const { data: city, loading, error, reload } = useTspCityKnowledge(locationId);
  const perms = useTspKnowledgePerms();

  let body;
  if (loading) {
    body = <TspSkeleton variant="row" count={3} label={`Loading the summary of ${cityName}`} />;
  } else if (error?.response?.status === 404) {
    body = <p className="tsp-muted-text">No summary for {cityName} yet — a place&apos;s summary is available once a journey that visited it has been completed.</p>;
  } else if (error || !city) {
    body = <TspLoadError error={error} onRetry={reload} what={`the summary of ${cityName}`} />;
  } else {
    body = (
      <div className="tsp-city-summary-sections">
        <CityKnowledgeSections city={city} perms={perms} idPrefix={`summary-${locationId}-`} />
      </div>
    );
  }

  return (
    <div className="tsp-city-summary" role="region" aria-label={`Summary of ${cityName}`}>
      {body}
    </div>
  );
}
